// all variables that will be constants and should be reused across the project
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '48a1ccda-da46-49d3-978c-48957f2d95d3';
export const MODAL_CLOSE_SEC = 2.5;
